import React, { useEffect, useRef } from 'react';
import { TweenMax, Power3 } from 'gsap';
import '../styles/Page.scss';

const About = () => {
    let content = useRef(null);

    useEffect(() => {
        TweenMax.to(content, 1, { opacity: 1, y: 0, ease: Power3.easeOut, delay: 0.2 });
    }, []);

    return (
        <div className="page about-page">
            <div className="container" ref={el => content = el}>
                <section className="legacy-section">
                    <div className="legacy-content">
                        <h1 className="section-title">Our Legacy</h1>
                        <p className="text-body">Founded in 2045, Odyssey began with a simple mission: to make the stars accessible to everyone.</p>
                        <p className="text-body">What started as a single lunar shuttle has grown into the solar system's premier luxury spaceline. We don't just transport you; we transform you.</p>
                        <div className="stat-grid">
                            <div className="stat"><h3>50+</h3><span>years</span></div>
                            <div className="stat"><h3>10k</h3><span>voyages</span></div>
                            <div className="stat"><h3>0</h3><span>accidents</span></div>
                        </div>
                    </div>
                    <div className="legacy-visual">
                        {/* Holographic Timeline Visual */}
                        <div className="holo-globe-small"></div>
                        <div className="holo-lines"></div>
                    </div>
                </section>

                <section className="sustainability-section">
                    <h2 className="section-title">Green Space Initiative <span>2090</span></h2>
                    <div className="sustainability-grid">
                        <div className="card">
                            <h3>Solar Sails</h3>
                            <p>Harnessing photon pressure for zero-emission cruising.</p>
                        </div>
                        <div className="card">
                            <h3>Closed Loop</h3>
                            <p>100% water and air recycling efficiency onboard.</p>
                        </div>
                        <div className="card">
                            <h3>Bio-Fuel</h3>
                            <p>Algae-based propulsion for atmospheric entry.</p>
                        </div>
                    </div>
                </section>

                <section className="awards-section">
                    <h2 className="section-title">Galactic Recognition</h2>
                    <div className="awards-grid">
                        <div className="award"><span role="img" aria-label="trophy">🏆</span> Best Luxury Spaceline '88</div>
                        <div className="award"><span role="img" aria-label="star">⭐</span> Safety First Award '89</div>
                        <div className="award"><span role="img" aria-label="earth globe">🌍</span> Earth Preservation Medal</div>
                    </div>
                </section>

                <section className="team-section">
                    <h2 className="section-title">Visionaries</h2>
                    <div className="team-grid">
                        <div className="team-member">
                            <h3>Dr. Elena Vostok</h3>
                            <p>Founder & CEO</p>
                        </div>
                        <div className="team-member">
                            <h3>Jaxon T.</h3>
                            <p>Head of Stellar Navigation</p>
                        </div>
                        <div className="team-member">
                            <h3>Sarah Chen</h3>
                            <p>Chief Experience Officer</p>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default About;
